import { ColorEnum } from '@enum/style/color.enum';

import { TitleStyleInterface } from './title-style.interface';

export const TitleDarkTheme: TitleStyleInterface = {
  colorNavAuthTitle: ColorEnum.Black20,

  colorSignUpTitle: ColorEnum.Black100,
  colorSignUpDescription: ColorEnum.Black100,
  colorSignUpSocialTitle: ColorEnum.Black100,

  colorConsumerCardTitle: ColorEnum.Black70,
  colorConsumerCardValue: ColorEnum.Black100,
  colorConsumerButtonTitle: ColorEnum.Black100,

  colorCredentialButtonTitle: ColorEnum.Black100,

  colorPageTitle: ColorEnum.Black100,
  colorPageDescription: ColorEnum.Black100,
};
